import Row from "./Row";

export default function Actions({ children, className = "" }) {
  return <Row className={className}>{children}</Row>;
}
